import { PricingInfo } from '../types/generated';

export function displayProductWasPrice(
  isContractPrice: boolean,
  showSecondaryPrice: boolean,
  pricingInfo: PricingInfo
): boolean {
  return (
    !isContractPrice &&
    pricingInfo.primaryWasPrice.value > 0 &&
    pricingInfo.primaryWasPrice.value > pricingInfo.primaryPrice.value &&
    (showSecondaryPrice
      ? pricingInfo.secondaryWasPrice.value > 0 &&
        pricingInfo.secondaryWasPrice.value > pricingInfo.secondaryPrice.value
      : true)
  );
}
